"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAssignmentSerializer = void 0;
var models_1 = require("../../models");
var constants_1 = require("../../constants");
/**
 * Serializes user assignment
 *
 * @author jennifer.ajoy
 */
var UserAssignmentSerializer = /** @class */ (function () {
    function UserAssignmentSerializer(assignmentSerializer) {
        this.assignmentSerializer = assignmentSerializer;
    }
    UserAssignmentSerializer.prototype.serialize = function (_a) {
        var id = _a.id, assignment = _a.assignment, districtId = _a.districtId, schoolId = _a.schoolId, enrollmentPeriodId = _a.enrollmentPeriodId, assigneeId = _a.assigneeId, startedAt = _a.startedAt, completedAt = _a.completedAt, status = _a.status;
        var serializedStudentAssignment = assignment
            ? this.assignmentSerializer.serialize(assignment)
            : undefined;
        return new models_1.UserAssignment({
            id: id,
            assignment: serializedStudentAssignment,
            districtId: districtId,
            schoolId: schoolId,
            enrollmentPeriodId: enrollmentPeriodId,
            assigneeId: assigneeId,
            startedAt: startedAt,
            completedAt: completedAt,
            status: status ? (0, constants_1.getUserAssignmentStatusFrom)(status) : undefined,
        });
    };
    return UserAssignmentSerializer;
}());
exports.UserAssignmentSerializer = UserAssignmentSerializer;
